import { render, staticRenderFns } from "./MyBalances.vue?vue&type=template&id=2d749508"
import script from "./MyBalances.vue?vue&type=script&lang=js"
export * from "./MyBalances.vue?vue&type=script&lang=js"
import style0 from "./MyBalances.vue?vue&type=style&index=0&id=2d749508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports